module.exports = __webpack_public_path__ + "akne_6_after_tn.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures_tn/dermatologie/akne_6_after_tn.jpg
// module id = 1393
// module chunks = 0